import React, { useState } from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Main from 'layouts/Main';
import Divider from '@mui/material/Divider';
import Container from 'components/Container';
import {
  About,
  VideoSection,
  CaseStudy1,
  CaseStudy2,
  CaseStudy3,
  Pricings,
  Download,
  AlertBanner,
} from './components';

const IndexView = (): JSX.Element => {
  const theme = useTheme();
  const [alertMessage, setAlertMessage] = useState<string | null>(null);

  return (
    <Box sx={{ overflowX: 'hidden' }}>
      <Main bgcolor={'background.paper'}>
        <Box
          sx={{
            position: 'relative',
            paddingBottom: 8,
          }}
        >
          <Container position={'relative'} zIndex={3}>
            {alertMessage && (
              <AlertBanner message={alertMessage} severity="error" />
            )}
          </Container>
        </Box>
        <Box
          sx={{
            backgroundColor: theme.palette.alternate.main,
            backgroundImage: `linear-gradient(120deg, ${theme.palette.background.paper} 0%, ${theme.palette.alternate.main} 100%)`,
            position: 'relative',
            marginTop: -13,
            paddingTop: 13,
          }}
        >
          <Container position={'relative'} zIndex={3}>
            <About />
          </Container>
          <Box
            component={'svg'}
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 1921 273"
            sx={{
              position: 'absolute',
              width: '100%',
              left: 0,
              bottom: 0,
              right: 0,
              zIndex: 1,
              height: '35%',
            }}
          >
            <polygon
              fill={theme.palette.background.paper}
              points="0,273 1921,273 1921,0 "
            />
          </Box>
        </Box>
        <Container>
          <VideoSection />
        </Container>
        {/* <Container>
          <Services />
        </Container> */}
        <Container>
          <CaseStudy1 />
        </Container>
        <Container paddingY={'0 !important'}>
          <CaseStudy2 />
        </Container>
        <Container>
          <CaseStudy3 />
        </Container>
        <Box
          sx={{
            backgroundImage: `linear-gradient(to bottom, ${alpha(
              theme.palette.background.paper,
              0,
            )}, ${alpha(theme.palette.alternate.main, 1)} 100%)`,
            backgroundRepeat: 'repeat-x',
            position: 'relative',
          }}
        >
          {/* <Container maxWidth={600}>
            <QuickStart />
          </Container> */}
          {/* <Container>
            <Features />
          </Container>
          <Container>
            <Benefits />
          </Container> */}
          <Box
            component={'svg'}
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 1920 100.1"
            sx={{
              width: '100%',
              marginBottom: theme.spacing(-1),
            }}
          >
            <path
              fill={theme.palette.background.paper}
              d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
            ></path>
          </Box>
        </Box>
        {/* <Container>
          <GetStarted />
        </Container> */}
        <Box position={'relative'} bgcolor={'alternate.main'}>
          <Container>
            <Pricings setAlertMessage={setAlertMessage} />
          </Container>
          <Box
            component={'svg'}
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 1920 100.1"
            sx={{
              width: '100%',
              marginBottom: theme.spacing(-1),
            }}
          >
            <path
              fill={theme.palette.background.default}
              d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
            ></path>
          </Box>
        </Box>

        <Divider />
        <Container>
          <Download />
        </Container>
        <Divider />
      </Main>
    </Box>
  );
};

export default IndexView;
